/* Igenar · comportamiento de las secciones de portada.
   Se inicializa por sección para funcionar también en el editor de temas. */
(function () {
  /* El archivo se incluye una vez por sección: se ejecuta solo la primera vez */
  if (window.__igHomeLoaded) return;
  window.__igHomeLoaded = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clp = function (n) { return '$' + Math.round(n).toLocaleString('es-CL'); };
  var m2 = function (n) { return n.toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m²'; };

  /* igAddQuote (agregar a cotización) está definido en línea en snippets/ig-assets.liquid */

  function initSlider(root) {
    var slides = root.querySelectorAll('.ig-slide');
    var dots = root.querySelectorAll('.ig-dots button');
    if (slides.length < 2) return;
    var cur = 0, timer = null;
    var secs = parseInt(root.dataset.autoplay || '0', 10);
    function go(i) {
      slides[cur].classList.remove('is-on'); dots[cur] && dots[cur].classList.remove('is-on');
      cur = (i + slides.length) % slides.length;
      slides[cur].classList.add('is-on'); dots[cur] && dots[cur].classList.add('is-on');
    }
    function restart() {
      clearInterval(timer);
      if (secs > 0 && !reduced) timer = setInterval(function () { go(cur + 1); }, secs * 1000);
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); restart(); }); });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    restart();
    root._igStop = function () { clearInterval(timer); };
  }

  function initRail(root) {
    var rail = root.querySelector('.ig-rail');
    var l = root.querySelector('.ig-arrow--l'), r = root.querySelector('.ig-arrow--r');
    if (!rail) return;
    /* Sin flechas cuando todos los productos caben a la vista */
    var toggle = function () {
      var fits = rail.scrollWidth <= rail.clientWidth + 2;
      if (l) l.hidden = fits;
      if (r) r.hidden = fits;
    };
    toggle();
    window.addEventListener('resize', toggle);
    l && l.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); });
    r && r.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); });
  }

  function initCountdown(root) {
    var end = new Date(root.dataset.end);
    if (isNaN(end)) { root.hidden = true; return; }
    var parts = root.querySelectorAll('b');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var s = Math.max(0, Math.floor((end - new Date()) / 1000));
      if (s === 0) { root.hidden = true; clearInterval(t); return; }
      var d = Math.floor(s / 86400); s %= 86400;
      var h = Math.floor(s / 3600); s %= 3600;
      var mi = Math.floor(s / 60); s %= 60;
      [d, h, mi, s].forEach(function (v, i) { if (parts[i]) parts[i].textContent = pad(v); });
    }
    var t = setInterval(tick, 1000); tick();
    root._igStop = function () { clearInterval(t); };
  }

  function initCalc(root) {
    var largo = root.querySelector('[data-ig-largo]');
    var ancho = root.querySelector('[data-ig-ancho]');
    var prod = root.querySelector('[data-ig-prod]');
    var out = {
      area: root.querySelector('[data-ig-area]'),
      buy: root.querySelector('[data-ig-buy]'),
      total: root.querySelector('[data-ig-total]')
    };
    var cta = root.querySelector('[data-ig-cta]');
    Array.prototype.forEach.call(prod.options, function (o) {
      var p = parseFloat(o.dataset.price || '0');
      if (p > 0 && o.textContent.indexOf('$') === -1) o.textContent = o.textContent.trim() + ' · ' + clp(p) + ' m²';
    });
    function run() {
      var opt = prod.options[prod.selectedIndex];
      if (!opt) return;
      var price = parseFloat(opt.dataset.price || '0');
      var area = (parseFloat(largo.value) || 0) * (parseFloat(ancho.value) || 0);
      /* m² exactos, sin margen por porcentaje */
      var buy = Math.round(area * 100) / 100;
      out.area.textContent = m2(area);
      if (out.buy) out.buy.textContent = m2(buy);
      out.total.textContent = clp(buy * price);
      if (cta) {
        cta.href = opt.dataset.url || '#';
        cta.textContent = 'Cotizar ' + m2(buy) + ' de este piso';
      }
    }
    root.addEventListener('input', run);
    root.addEventListener('change', run);
    run();
  }

  function initHours(root) {
    var now;
    try { now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' })); }
    catch (e) { now = new Date(); }
    var day = now.getDay();
    var hm = now.getHours() * 60 + now.getMinutes();
    var open = false;
    root.querySelectorAll('tr[data-day]').forEach(function (tr) {
      if (parseInt(tr.dataset.day, 10) !== day) return;
      tr.classList.add('is-today');
      var o = tr.dataset.open, c = tr.dataset.close;
      if (o && c) {
        var toMin = function (s) { var p = s.split(':'); return parseInt(p[0], 10) * 60 + parseInt(p[1] || '0', 10); };
        open = hm >= toMin(o) && hm < toMin(c);
      }
    });
    var badge = root.querySelector('.ig-open');
    if (badge) {
      badge.classList.toggle('is-open', open);
      badge.querySelector('span').textContent = open ? 'Abierto ahora' : 'Cerrado ahora';
    }
  }

  /* Parallax: el fondo se desplaza más lento que el contenido.
     Solo se calcula mientras el contenedor está en pantalla. */
  var parallaxItems = [];
  var parallaxTicking = false;
  function parallaxUpdate() {
    parallaxTicking = false;
    var vh = window.innerHeight;
    parallaxItems.forEach(function (it) {
      if (!it.visible) return;
      var rect = it.box.getBoundingClientRect();
      /* Margen extra del fondo, fijo en el CSS (18vh o 6vh) para que la página no salte al cargar */
      var pad = vh * (it.speed >= 0.2 ? 0.18 : 0.06) - 1;
      /* Distancia del centro del contenedor al centro de la pantalla */
      var offset = rect.top + rect.height / 2 - vh / 2;
      var shift = -offset * it.speed;
      if (shift > pad) shift = pad;
      if (shift < -pad) shift = -pad;
      it.el.style.setProperty('--ig-py', shift.toFixed(1) + 'px');
    });
  }
  function parallaxRequest() {
    if (parallaxTicking) return;
    parallaxTicking = true;
    window.requestAnimationFrame(parallaxUpdate);
  }
  function initParallax(el) {
    if (reduced || el._igParallax || !('IntersectionObserver' in window)) return;
    el._igParallax = true;
    var item = { el: el, box: el.parentElement, speed: parseFloat(el.dataset.igParallax) || 0.1, visible: false };
    parallaxItems.push(item);
    new IntersectionObserver(function (entries) {
      item.visible = entries[0].isIntersecting;
      if (item.visible) parallaxRequest();
    }, { rootMargin: '100px 0px' }).observe(item.box);
    if (parallaxItems.length === 1) {
      window.addEventListener('scroll', parallaxRequest, { passive: true });
      window.addEventListener('resize', parallaxRequest);
      /* El alto de la página cambia mientras cargan imágenes y fuentes */
      window.addEventListener('load', parallaxRequest);
      setTimeout(parallaxRequest, 600);
    }
  }

  /* Vitrina de ofertas: filtro por categoría y orden */
  function initDeals(root) {
    var grid = root.querySelector('[data-ig-grid]');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.ig-deals__item'));
    var chips = root.querySelectorAll('[data-ig-filter]');
    var sort = root.querySelector('[data-ig-sort]');
    var empty = root.querySelector('[data-ig-empty]');
    var current = 'all';
    /* Contadores y ocultar categorías sin productos */
    chips.forEach(function (c) {
      var f = c.getAttribute('data-ig-filter');
      var n = f === 'all' ? items.length : items.filter(function (i) { return i.dataset.cat === f; }).length;
      var badge = c.querySelector('[data-count]');
      if (badge) badge.textContent = '(' + n + ')';
      if (n === 0 && f !== 'all') c.hidden = true;
    });
    var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 8;
    var limit = pageSize;
    var more = root.querySelector('[data-ig-more]');
    function apply() {
      var shown = 0, total = 0;
      Array.prototype.forEach.call(grid.children, function (i) {
        if (!i.classList.contains('ig-deals__item')) return;
        var ok = current === 'all' || i.dataset.cat === current;
        if (ok) total++;
        var vis = ok && shown < limit;
        i.hidden = !vis;
        if (vis) shown++;
      });
      if (empty) empty.hidden = total > 0;
      if (more) {
        more.hidden = total <= limit;
        more.textContent = 'Ver más ofertas (' + (total - shown) + ')';
      }
    }
    if (more) more.addEventListener('click', function () { limit += pageSize; apply(); });
    function order() {
      var v = sort ? sort.value : 'off';
      var sorted = items.slice().sort(function (a, b) {
        if (v === 'off') return (+b.dataset.off) - (+a.dataset.off) || (+a.dataset.price) - (+b.dataset.price);
        if (v === 'price-asc') return (+a.dataset.price || Infinity) - (+b.dataset.price || Infinity);
        if (v === 'price-desc') return (+b.dataset.price) - (+a.dataset.price);
        return a.dataset.name.localeCompare(b.dataset.name, 'es');
      });
      sorted.forEach(function (i) { grid.appendChild(i); });
      apply();
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        current = c.getAttribute('data-ig-filter');
        limit = pageSize;
        chips.forEach(function (x) { var on = x === c; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        apply();
      });
    });
    if (sort) sort.addEventListener('change', order);
    order(); apply();
  }

  /* Aparición al hacer scroll: solo a lo que está bajo la pantalla al cargar,
     así nada queda invisible si el script falla o el cliente ya está abajo. */
  var REVEAL = '.ig-head, .ig-rail-wrap, .ig-cat, .ig-line, .ig-type, .ig-sector, .ig-benefit, .ig-brand, .ig-perk, .ig-feature, .ig-deals__item, .ig-calc, .ig-band__copy, .ig-showroom, .ig-b2b, .ig-faq__item, .ig-seotext';
  var revealIO = null;
  function initReveal(scope) {
    if (reduced || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          el.classList.add('ig-rv--in');
          revealIO.unobserve(el);
          /* Al terminar se quitan las clases para que el relieve al pasar el mouse vuelva a ser rápido */
          var d = parseInt(el.style.getPropertyValue('--rv-d'), 10) || 0;
          setTimeout(function () { el.classList.remove('ig-rv', 'ig-rv--in'); el.style.removeProperty('--rv-d'); }, 700 + d);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    var vh = window.innerHeight;
    scope.querySelectorAll(REVEAL).forEach(function (el) {
      if (el._igRv || !el.closest('.ig')) return;
      el._igRv = true;
      if (el.getBoundingClientRect().top < vh * 0.95) return;
      /* Escalonado entre hermanos: 70 ms cada uno, máximo 6 */
      var i = Array.prototype.indexOf.call(el.parentElement.children, el) % 6;
      el.style.setProperty('--rv-d', (i * 70) + 'ms');
      el.classList.add('ig-rv');
      revealIO.observe(el);
    });
  }

  /* Contador del "Hasta X%" del Cyber */
  function initCount(el) {
    if (reduced || el._igCount) return;
    el._igCount = true;
    var target = parseInt(el.textContent, 10);
    if (!target) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      var start = null;
      var step = function (t) {
        if (!start) start = t;
        var p = Math.min(1, (t - start) / 1200);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))) + '%';
        if (p < 1) window.requestAnimationFrame(step);
      };
      window.requestAnimationFrame(step);
    });
    io.observe(el);
  }

  /* Las cintas en movimiento se pausan cuando no están en pantalla */
  var pauseIO = null;
  function initPauseOffscreen(el) {
    if (el._igPause || !('IntersectionObserver' in window)) return;
    el._igPause = true;
    if (!pauseIO) pauseIO = new IntersectionObserver(function (en) {
      en.forEach(function (e) { e.target.classList.toggle('is-off', !e.isIntersecting); });
    }, { rootMargin: '100px 0px' });
    pauseIO.observe(el);
  }

  function init(scope) {
    scope.querySelectorAll('.ig-cyber__big b, .ig-cyb__off b').forEach(initCount);
    scope.querySelectorAll('[data-ig-deals]').forEach(initDeals);
    /* Sin parallax ni aparición al hacer scroll: el scroll queda 100% fluido */
    scope.querySelectorAll('.ig-marquee, .ig-brand-row').forEach(initPauseOffscreen);
    scope.querySelectorAll('[data-ig-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-ig-rail]').forEach(initRail);
    scope.querySelectorAll('[data-ig-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-ig-calc]').forEach(initCalc);
    scope.querySelectorAll('[data-ig-hours]').forEach(initHours);
  }

  function stop(scope) {
    scope.querySelectorAll('[data-ig-slider],[data-ig-countdown]').forEach(function (el) { el._igStop && el._igStop(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Editor de temas */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { stop(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.ig-slide');
    if (!slide) return;
    var slider = slide.closest('[data-ig-slider]');
    var i = Array.prototype.indexOf.call(slider.querySelectorAll('.ig-slide'), slide);
    var dot = slider.querySelectorAll('.ig-dots button')[i];
    dot && dot.click();
  });
})();
